const ResellerStatus = Object.freeze({
    NewRequest: "NewRequest",
    PendingRequest: "PendingRequest",
    Approved: "Approved",
    Denied: "Denied"
});

export default ResellerStatus;